<div class="flex-column justify-content-center align-items-center banner v4-bg-img">
    <!-- <div #air id="air" class='air'></div> -->
    <div class="v4-login-card p-4 w-full lg:w-6">
        <div class="text-center mb-5">
            <img class="signup-logo mb-3" src="../../../assets/v-4-icone/Vector.png" alt="Image" height="50">
        </div>
        <h3 class="sstarabicbold text-center color-grey pb-2">{{"Password Reset" | translator}}</h3>
        <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()" dir="rtl" [style.fontSize.px]="12">
            <div class="form-group clearfix" [ngClass]="{ 'has-error': submitted }">

                <label class="ms-label-view"> {{"Current password" | translator}}</label>
                <div class="d-flex-item-center">
                    <input [type]="hide3 ? 'password' : 'text'" formControlName="oldPassword"
                        placeholder='{{"Current password" | translator}}' pInputText class="w-full mb-3 text-start ms-input-view"
                        (blur)="trimPasswordField('oldPassword')">
                    <div *ngIf="hide3; else elseBlock3"> <i (click)="hide3 = !hide3"
                            class="fa-regular fa-eye-slash font-1rem mx-2 color-grey"></i></div>
                    <ng-template #elseBlock3><i (click)="hide3 = !hide3"
                            class="fa-regular fa-eye font-1rem mx-2 color-grey"></i></ng-template>
                </div>

                <label class="font-12 ms-label-view">{{"New Password" | translator}}</label>
                <div class="d-flex-item-center">
                    <input [type]="hide ? 'password' : 'text'" formControlName="password"
                        [(ngModel)]="password1" placeholder='{{"New Password" | translator}}' pInputText class="w-full mb-3 text-start ms-input-view"
                        (blur)="trimPasswordField('password')">
                    <div *ngIf="hide; else elseBlock"> <i (click)="hide = !hide"
                            class="fa-regular fa-eye-slash font-1rem mx-2 color-grey"></i></div>
                    <ng-template #elseBlock><i (click)="hide = !hide"
                            class="fa-regular fa-eye font-1rem mx-2 color-grey"></i></ng-template>
                </div>


            </div>
            <div class="form-group clearfix" [ngClass]="{ 'has-error': submitted }">

                <label class="font-12 ms-label-view">{{"Confirm the new password" | translator}}</label>
                <div class="d-flex-item-center">
                    <input [type]="hide2 ? 'password' : 'text'" formControlName="conformPassword"
                        [(ngModel)]="password2" placeholder='{{"Confirm the new password" | translator}}' pInputText class="w-full mb-3 text-start ms-input-view"
                        (blur)="trimPasswordField('conformPassword')">
                    <div *ngIf="hide2; else elseBlock2"> <i (click)="hide2 = !hide2"
                            class="fa-regular fa-eye-slash font-1rem mx-2 color-grey"></i></div>
                    <ng-template #elseBlock2><i (click)="hide2 = !hide2"
                            class="fa-regular fa-eye font-1rem mx-2 color-grey"></i></ng-template>
                </div>


                <div dir="rtl" class="row mb-2 text-end px-2">
                    <h6 class="text-center color-grey">{{"Password creation requirements" | translator}}</h6>
                    <div class="col-md-4 text-start" >
                        <div [ngClass]=" checkpassword() ? 'text-green' : 'text-red'">
                        <i [hidden]="checkpassword()" class="fa fa-times-circle" aria-hidden="true"></i>
                        <i [hidden]="!checkpassword()" class="fa fa-check-circle" aria-hidden="true"></i>
                        {{"Password match" | translator}}
                    </div>
                    </div>

                    <div class="col-md-4 text-start">
                        <div [ngClass]=" atleast8() ? 'text-green' : 'text-red'">
                        <i [hidden]="atleast8()" class="fa fa-times-circle" aria-hidden="true"></i>
                        <i [hidden]="!atleast8()" class="fa fa-check-circle" aria-hidden="true"></i>
                        {{"At least 8 characters" | translator}}
                    </div>
                    </div>

                    <div class="col-md-4 text-start">
                        <div [ngClass]=" atleastcapital() ? 'text-green' : 'text-red'">
                        <i [hidden]="atleastcapital() " class="fa fa-times-circle" aria-hidden="true"></i>
                        <i [hidden]="!atleastcapital() " class="fa fa-check-circle" aria-hidden="true"></i>
                        {{"One uppercase letter (at least)" | translator}}
                    </div>
                    </div>

                    <div class="col-md-4 text-start">
                        <div [ngClass]=" atleastsmall() ? 'text-green' : 'text-red'">
                        <i [hidden]="atleastsmall() " class="fa fa-times-circle" aria-hidden="true"></i>
                        <i [hidden]="!atleastsmall() " class="fa fa-check-circle" aria-hidden="true"></i>
                        {{"One lowercase letter (at least)" | translator}}
                    </div>
                    </div>

                    <div class="col-md-4 text-start">
                        <div [ngClass]=" atleastnumber() ? 'text-green' : 'text-red'">
                        <i [hidden]="atleastnumber() " class="fa fa-times-circle" aria-hidden="true"></i>
                        <i [hidden]="!atleastnumber() " class="fa fa-check-circle" aria-hidden="true"></i>
                        {{"One number (at least)" | translator}}
                    </div>
                    </div>

                    <div class="col-md-4 text-start">
                        <div [ngClass]=" atleastspecial() ? 'text-green' : 'text-red'">
                        <i [hidden]="atleastspecial() " class="fa fa-times-circle" aria-hidden="true"></i>
                        <i [hidden]="!atleastspecial() " class="fa fa-check-circle" aria-hidden="true"></i>
                        {{"One special code (at least)" | translator}}
                    </div>
                    </div>
                </div>


            </div>

            <p *ngIf="message" style="color: red;" class="text-center error"> {{message}}</p>

            <div class="col-xs-12 form-group text-right">
                <button type="submit" pButton pRipple  label='{{"OK" | translator}}'  icon="pi pi-key" class="w-full v4-login-btn"></button>
            </div>
        </form>
    </div>
    <div class="text-center pt-3 ">
        <!-- <span class="white">{{"Do you want to reset your password?" | translator}}</span>
        &nbsp;&nbsp; -->

        <span (click)="redirectHome()" class="bottom-btns2">
            {{"If you do not want to reset your password, you can click here to return to the home page" | translator}}
        </span>
    </div>
</div>
